import { useCallback, useState } from 'react';

export default function useClipboard () {
  const [copiedText, setCopiedText] = useState(null);

  const copy = useCallback(async text => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      return true;
    } catch (error) {
      console.warn('Copy failed', error);
      setCopiedText(null);
      return false;
    }
  }, []);

  return [copy, copiedText];
}
